/**********************************************************/
/* Multibuy JS Start **************************************/
/**********************************************************/
const $ = require('jquery');

module.exports = {
  init_multibuy: function() {
    // Function to get cookie value
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    // Function to set cookie
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/`;
    }

    // Once a product is in the multibuy, its "Add To Multibuy" button becomes
    // a "View My Multibuy" link to the multibuy page (Beckie, Aug 2026 — the
    // old site did this). The destination is the ACF `multibuy` option passed
    // through ajax_object, with a slug fallback so the button still works if
    // the option is ever empty.
    const MULTIBUY_URL = (typeof ajax_object !== 'undefined' && ajax_object.multibuy_url)
      ? ajax_object.multibuy_url
      : '/multibuy/';
    const MULTIBUY_VIEW_LABEL = 'View My Multibuy';

    // Add a product to the multibuy cookie. Duplicates are allowed —
    // each click of `.multi-buy-btn` pushes another entry, so clicking
    // a button twice means qty 2 of that product. The cookie is just an
    // append-only list of product IDs; the multibuy form server-side
    // iterates that list as one row per entry.
    //
    // Modal-open rule: open only on the FIRST add of a given product,
    // so the customer gets a confirmation/visual on initial selection
    // but isn't bombarded with re-opens when they're stacking duplicates
    // (clicking twice to set qty 2). The `show.bs.modal` handler below
    // takes care of refreshing the modal contents on every open.
    function addToMultibuy(productId) {
      let multibuy = getCookie('multibuy');
      let productIds = [];

      if (multibuy) {
        productIds = JSON.parse(decodeURIComponent(multibuy));
      }

      const isFirstInstance = !productIds.includes(productId);

      productIds.push(productId);
      setCookie('multibuy', encodeURIComponent(JSON.stringify(productIds)), 7);

      updateMultibuyCount();

      if (isFirstInstance) {
        $('#multibuyModal').modal('show');
      }
    }

    // AJAX-refresh the modal's product list. Triggered automatically
    // whenever the modal is shown, so it always reflects the latest
    // cookie state without needing the click handler to coordinate it.
    function refreshMultibuyModalContent() {
      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: { action: 'get_multibuy_products' },
        success: function(response) {
          if (response && response.success) {
            const $productContainer = $('#multibuy-products-container');
            if ($productContainer.length) {
              $productContainer.html(response.data.html);
            }
          }
        }
      });
    }

    $(document).on('show.bs.modal', '#multibuyModal', refreshMultibuyModalContent);

    // Function to update multibuy count display.
    //
    //   - `.multi-qty` INSIDE a `.multi-buy-btn` shows the qty for THAT
    //     button's product (read from `data-product-id`). Lets a
    //     customer eyeball "I've already added 2 of this product" on
    //     the card itself.
    //   - `.multi-qty` OUTSIDE any button (e.g. the nav-header badge in
    //     _navigation.php) keeps showing the global total across all
    //     products in the multibuy cookie.
    function updateMultibuyCount() {
      const multibuy = getCookie('multibuy');
      const productIds = multibuy ? JSON.parse(decodeURIComponent(multibuy)) : [];

      // Per-product tally — keyed by string product_id so it round-trips
      // cleanly with `.data('product-id')` (which jQuery may coerce to
      // a number, but normalising both sides as strings is safest).
      const countByProduct = {};
      for (const id of productIds) {
        const key = String(id);
        countByProduct[key] = (countByProduct[key] || 0) + 1;
      }

      // Per-product state on every Multibuy button. Once a product is in the
      // multibuy (count > 0) the button turns into a "View My Multibuy" link to
      // the multibuy page; at zero it stays the normal "Add To Multibuy" button
      // with its qty badge. Done in the browser on purpose: product and listing
      // pages are edge-cached, so this per-customer state can only be applied
      // client-side, off the multibuy cookie.
      $('.multi-buy-btn').each(function() {
        const $btn = $(this);
        const pid = String($btn.data('product-id'));
        const count = countByProduct[pid] || 0;

        // Stash the original "add" markup once, so a product cleared from the
        // multibuy within the same page can be restored to its add button.
        if ($btn.data('mbAddHtml') === undefined) {
          $btn.data('mbAddHtml', $btn.html());
        }

        if (count > 0) {
          if (!$btn.hasClass('is-in-multibuy')) {
            $btn.addClass('is-in-multibuy').html(MULTIBUY_VIEW_LABEL);
          }
        } else {
          if ($btn.hasClass('is-in-multibuy')) {
            $btn.removeClass('is-in-multibuy').html($btn.data('mbAddHtml'));
          }
          $btn.find('.multi-qty').text(count);
        }
      });

      // Global badges (anything else with the .multi-qty class — the
      // nav-header counter is the main one).
      $('.multi-qty').not('.multi-buy-btn .multi-qty').text(productIds.length);
    }

    // Event listener for all multibuy buttons.
    //
    // addToMultibuy() handles the cookie write + the modal-on-first-add
    // rule. Same behaviour everywhere — including inside #compare-overlay
    // — so re-adding a product that's already in the multibuy never
    // re-opens the modal.
    $(document).on('click', '.multi-buy-btn', function(e) {
      e.preventDefault();
      const $btn = $(this);

      // In its "View My Multibuy" state the button is a link to the multibuy
      // page, not an add control.
      if ($btn.hasClass('is-in-multibuy')) {
        window.location.href = MULTIBUY_URL;
        return;
      }

      const productId = $btn.data('product-id');
      if (productId) {
        addToMultibuy(productId);
      }
    });

    // Initialize count on page load
    updateMultibuyCount();

    // Re-run when other parts of the site swap in fresh markup that
    // contains `.multi-buy-btn` instances — currently the compare
    // overlay's AJAX replace fires this. Listening on `document` keeps
    // this loosely coupled; any future block that re-renders cards
    // can trigger the same event without coupling to this file.
    $(document).on('tdm:multibuy-counts-need-update', updateMultibuyCount);

    // Multibuy Form JS
    var multibuyFormId = null;
    function multiBuyForm() {
      var $form = $('.multi-buy-form');

      if (!$form.length) {
        return;
      }

      // Capture this Gravity Forms form's id once, so we can clear the multibuy
      // after a successful submission of THIS form (see gform_confirmation_loaded).
      if (multibuyFormId === null) {
        var $gf = $form.find('form[id^="gform_"]');
        var idMatch = $gf.length ? ($gf.attr('id') || '').match(/gform_(\d+)/) : null;
        if (idMatch) { multibuyFormId = parseInt(idMatch[1], 10); }
      }

      // Use .data() instead of attr + JSON.parse
      var productDetails = $form.data('product-details');

      if (!productDetails) {
        console.log('No product details found');
        return;
      }

      // Field mapping object
      var fieldMap = {
        '.multibuy-product-ids input': productDetails.product_ids,
        '.multibuy-product-qty input': productDetails.product_qty,
        '.multibuy-user-id input': productDetails.user_id
      };

      // Loop through and set values. Do NOT trigger 'change' here — these are
      // hidden fields and firing change cascades into Gravity Forms'
      // conditional logic engine, which can wipe sibling field values.
      $.each(fieldMap, function(selector, value) {
        if (value) { // Only set if value exists
          $form.find(selector).val(value);
        }
      });
    }

    multiBuyForm();

    // Gravity Forms re-renders the form on AJAX validation errors and
    // conditional logic updates. Each re-render wipes our JS-populated hidden
    // fields, so re-apply them whenever GF re-renders.
    $(document).on('gform_post_render', function() {
      multiBuyForm();
    });

    // Clear the multibuy after a successful quote submission (Ash, 4 Aug:
    // "after submitting a multibuy request, it doesn't clear"). GF fires this
    // when its AJAX confirmation replaces the form; scoped to the multibuy form
    // so submitting any other GF form on the site leaves the multibuy alone.
    $(document).on('gform_confirmation_loaded', function (e, formId) {
      if (multibuyFormId && parseInt(formId, 10) === multibuyFormId) {
        document.cookie = 'multibuy=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        updateMultibuyCount();
        $('.section-multibuy-product-list').hide();
      }
    });

    // Format a number as GBP to match wc_price() output — £, comma thousands,
    // two decimals (e.g. 2345 -> "£2,345.00").
    function fmtGBP(n) {
      return '£' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Recalculate the per-card line totals and the running estimated total.
    // Reads the live quantity straight off each card's qty input, skips POA
    // cards (no price to sum), and hides a line total at qty 1 (it would just
    // echo the unit price). DOM-only and cheap, so safe to call on every change.
    function recalcMultibuyTotals() {
      var grand = 0;

      $('.multibuy-product-card').each(function () {
        var $card = $(this);
        if ($card.attr('data-poa') === '1') {
          return; // POA — excluded from totals
        }

        var unit = parseFloat($card.attr('data-unit-price')) || 0;
        var qty  = parseInt($card.find('input.qty').val(), 10);
        if (!qty || qty < 1) { qty = 1; }

        var line = unit * qty;
        grand += line;

        $card.find('.multibuy-line-qty').text(qty);
        $card.find('.multibuy-line-total-value').text(fmtGBP(line));
        // Only surface the line total once it adds information (qty > 1).
        $card.find('.multibuy-line-total').toggle(qty > 1);
      });

      $('.multibuy-grand-total-value').text(fmtGBP(grand));
    }

    // Persist a product's quantity into the multibuy cookie. The cookie is an
    // append-only list of product IDs (quantity = how many times an ID appears),
    // so we rebuild it with `qty` copies of this product while preserving the
    // existing order and every other product's count. Without this, quantities
    // set on the Multibuy page were never written back, so leaving the page and
    // returning reset them all to 1 (Josie/Lucy/Ash, 4 Aug).
    function setMultibuyQty(productId, qty) {
      productId = parseInt(productId, 10);
      qty = Math.max(1, parseInt(qty, 10) || 1);
      if (!productId) { return; }

      var multibuy = getCookie('multibuy');
      var ids = multibuy ? JSON.parse(decodeURIComponent(multibuy)) : [];

      // Count current entries per product, keeping first-seen order.
      var order = [];
      var counts = {};
      ids.forEach(function (id) {
        id = parseInt(id, 10);
        if (!id) { return; }
        if (!(id in counts)) { counts[id] = 0; order.push(id); }
        counts[id]++;
      });
      if (!(productId in counts)) { order.push(productId); }
      counts[productId] = qty;

      var rebuilt = [];
      order.forEach(function (id) {
        for (var k = 0; k < counts[id]; k++) { rebuilt.push(id); }
      });

      setCookie('multibuy', encodeURIComponent(JSON.stringify(rebuilt)), 7);
      updateMultibuyCount();
    }

    // Quantity change on the Multibuy page. The +/- stepper fires 'change' on
    // the input (see woocommerce.js), and typing a value then blurring fires it
    // too, so one delegated handler covers both. Keeps the quote fields, the
    // live totals, and the cookie all in step, so typed AND stepped quantities
    // both reach the request and survive navigating away from the page.
    $(document).on('change', '.multibuy-product-card input.qty', function () {
      var $card  = $(this).closest('.multibuy-product-card');
      var newQty = parseInt($(this).val(), 10);
      if (!newQty || newQty < 1) { newQty = 1; }

      // jQuery's cache drives multiBuyFormUpdate(); keep the attribute in step
      // so recalcMultibuyTotals() (which reads the input) and the cache agree.
      $card.data('product-qty', newQty);
      $card.attr('data-product-qty', newQty);

      multiBuyFormUpdate();
      recalcMultibuyTotals();
      setMultibuyQty($card.data('product-id'), newQty); // persist across navigation
    });

    // Sync totals + line-total visibility to the server-rendered starting state.
    recalcMultibuyTotals();

    // Delete Multibuy Product
    $('.multibuy-product-card .multibuy-delete').on('click', function (){
      var productWrapper = $(this).closest('.multibuy-product-card');
      var productId = productWrapper.data('product-id');

      let multibuy = getCookie('multibuy');

      if (multibuy) {
        // Decode and parse the cookie value
        let productIds = JSON.parse(decodeURIComponent(multibuy));

        // Filter out the specific product ID (converts to number for comparison)
        productIds = productIds.filter(id => parseInt(id) !== parseInt(productId));

        if (productIds.length > 0) {
          // Update cookie with remaining IDs (7 days duration)
          setCookie('multibuy', encodeURIComponent(JSON.stringify(productIds)), 7);
        } else {
          // If empty, delete the cookie
          document.cookie = 'multibuy=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }

        // Remove from the DOM
        $(productWrapper).remove();

        updateMultibuyCount();
        multiBuyFormUpdate();
        recalcMultibuyTotals();

        // If we just deleted the last card, hide the whole multibuy
        // section. The PHP block guards against rendering when the
        // cookie is empty, but on this same page-load the section is
        // already in the DOM — without this we'd be left with an empty
        // shell + the form on its own.
        if ($('.multibuy-product-card').length === 0) {
          $('.section-multibuy-product-list').hide();
        }

        return true;
      }

      return false;
    });

    // Update Form Call
    function multiBuyFormUpdate() {
      var $form = $('.multi-buy-form');

      // Use .data() instead of attr + JSON.parse
      var productDetails = $form.data('product-details');

      var multibuyData = {
        "product_ids": [],
        "product_qty": [],
        "user_id": productDetails.user_id
      };

      // Loop through each product card
      $('.multibuy-product-card').each(function() {
        var productId = $(this).data('product-id');
        var productQty = $(this).data('product-qty');
        
        multibuyData.product_ids.push(productId);
        multibuyData.product_qty.push(parseInt(productQty));
      });

      if (!multibuyData) {
        console.log('No product details found');
        return;
      }
      
      // Field mapping object
      var fieldMap = {
        '.multibuy-product-ids input': multibuyData.product_ids,
        '.multibuy-product-qty input': multibuyData.product_qty,
        '.multibuy-user-id input': multibuyData.user_id
      };
      
      // Loop through and set values (no change trigger — see multiBuyForm)
      $.each(fieldMap, function(selector, value) {
        if (value) { // Only set if value exists
          $form.find(selector).val(value);
        }
      });
    }

    // Multibuy Clear / Reset
    $('.multibuy-clear').on('click', function(){
      // Delete the cookie by setting it to expire in the past
      document.cookie = 'multibuy=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      
      // Optional: Refresh page or update UI
      location.reload();
    });
  }
};
/**********************************************************/
/* Multibuy JS End ****************************************/
/**********************************************************/